import { DESKTOP_PROPERTIES } from '../../../Common/DesktopProperties/desktopProperties.constants'
import { SCREEN_RECORDING_PRIORITY, SCREEN_RECORDING_BITRATE, SCREEN_RECORDING_CPU } from '../../../Common/DesktopProperties/desktopProperties.constants'

export const SCREEN_RECORDING_QUALITY = {
  GOOD: 'GOOD',
  BETTER: 'BETTER',
  BEST: 'BEST',
}

export const SCREEN_RECORDING_FPS = {
  FPS_1: '1',
  FPS_2: '2',
  FPS_3: '3',
  FPS_4: '4',
}

const getScreenRecordingQuality = qmGlobalSettings => {
  if (SCREEN_RECORDING_CPU[SCREEN_RECORDING_QUALITY.BEST] === qmGlobalSettings.screenRecordingCPU &&
    SCREEN_RECORDING_BITRATE[SCREEN_RECORDING_QUALITY.BEST] === qmGlobalSettings.screenRecordingBitrate
  ) {
    return SCREEN_RECORDING_QUALITY.BEST
  } else if (SCREEN_RECORDING_CPU[SCREEN_RECORDING_QUALITY.BETTER] === qmGlobalSettings.screenRecordingCPU &&
    SCREEN_RECORDING_BITRATE[SCREEN_RECORDING_QUALITY.BETTER] === qmGlobalSettings.screenRecordingBitrate
  ) {
    return SCREEN_RECORDING_QUALITY.BETTER
  } else {
    return SCREEN_RECORDING_QUALITY.GOOD
  }
}

const strToFormInt = str => (!str ? '' : parseInt(str))
const strToFormBool = str => (!str || str === '0' ? false : true)

// Transform API response into form values
export const qmGlobalSettingsPropertiesToFormValues = qmGlobalSettings => {
  return {
    screenRecordingExtension: qmGlobalSettings.extendScreenRecording,
    endScreenRecordingOnNewCall: strToFormBool(qmGlobalSettings.EndScreenOnNewCall),
    talkoverThreshold: qmGlobalSettings.talkoverThreshold,
    silenceThreshold: qmGlobalSettings.silenceThreshold,
    recycleBinRetention: {
      value: qmGlobalSettings.retentionActualRecycleBinValue,
      unit: qmGlobalSettings.retentionActualRecycleBinUnit,
    },
    reconciliationRetention: {
      value: qmGlobalSettings.retentionActualReconciliationDataValue,
      unit: qmGlobalSettings.retentionActualReconciliationDataUnit,
    },
    recordingAudioRetention: {
      value: qmGlobalSettings.retentionActualRootRecordingValue,
      unit: qmGlobalSettings.retentionActualRootRecordingUnit,
    },
    recordingScreenRetention: {
      value: qmGlobalSettings.retentionActualRootScreenRecordingValue,
      unit: qmGlobalSettings.retentionActualRootScreenRecordingUnit,
    },
    nonCallRetention: {
      value: qmGlobalSettings.retentionActualNonCallValue,
      unit: qmGlobalSettings.retentionActualNonCallUnit,
    },
    useFirstCalling: trueFalseStrToFormBool(qmGlobalSettings.useFirstCalling),
    useFirstCalled: trueFalseStrToFormBool(qmGlobalSettings.useFirstCalled),
    useRTP: strToFormBool(qmGlobalSettings.useRTP),
    sipFilterPort: qmGlobalSettings.sipFilterPort,
    minContactDurationMs: strToFormInt(qmGlobalSettings.minContactDurationMs),
    maxContactDurationMs: strToFormInt(qmGlobalSettings.maxContactDurationMs),
    willDisplayContactInUserTimezone: strToFormBool(qmGlobalSettings.willDisplayContactInUserTimezone),
    stunTurnServerId: qmGlobalSettings.stunTurnServerId,
    ScreenRecordingPriority: qmGlobalSettings.ScreenRecordingPriority || SCREEN_RECORDING_PRIORITY.NO_PRIORITY,
    screenRecordingQuality: getScreenRecordingQuality(qmGlobalSettings),
    screenRecordingFPS: qmGlobalSettings.screenRecordingFPS || SCREEN_RECORDING_FPS.FPS_1,
    sharedMediaDirectory: qmGlobalSettings.sharedMediaDirectory,
    sharedMediaDirectoryUser: qmGlobalSettings.sharedMediaDirectoryUser,
    sharedMediaDirectoryPassword: qmGlobalSettings.sharedMediaDirectoryPassword,
  }
}

const formBoolToStr = formBool => (formBool ? '1' : '0')
const formIntToStr = formInt => formInt + ''

// Transform form values into API response
export const qmGlobalSettingsFormValuesToProperties = (qmGlobalSettings, sharedMediaDirectoryFlag) => {
  const qmGlobalProps = {
    willDisplayContactInUserTimezone: formBoolToStr(qmGlobalSettings.willDisplayContactInUserTimezone),
    extendScreenRecording: formIntToStr(qmGlobalSettings.screenRecordingExtension),
    EndScreenOnNewCall: formBoolToStr(qmGlobalSettings.endScreenRecordingOnNewCall),
    talkoverThreshold: formIntToStr(qmGlobalSettings.talkoverThreshold),
    silenceThreshold: formIntToStr(qmGlobalSettings.silenceThreshold),
    retentionActualRecycleBinValue: formIntToStr(qmGlobalSettings.recycleBinRetention.value),
    retentionActualRecycleBinUnit: qmGlobalSettings.recycleBinRetention.unit,
    useFirstCalling: formBoolToTrueFalseStr(qmGlobalSettings.useFirstCalling),
    useFirstCalled: formBoolToTrueFalseStr(qmGlobalSettings.useFirstCalled),
    useRTP: formBoolToStr(qmGlobalSettings.useRTP),
    sipFilterPort: qmGlobalSettings.sipFilterPort,
    maxContactDurationMs: formIntToStr(qmGlobalSettings.maxContactDurationMs),
    minContactDurationMs: formIntToStr(qmGlobalSettings.minContactDurationMs),
    stunTurnServerId: formIntToStr(qmGlobalSettings.stunTurnServerId),
    retentionActualReconciliationDataValue: formIntToStr(qmGlobalSettings.reconciliationRetention.value),
    retentionActualReconciliationDataUnit: qmGlobalSettings.reconciliationRetention.unit,

    retentionActualRootScreenRecordingValue: formIntToStr(qmGlobalSettings.recordingScreenRetention.value),
    retentionActualRootScreenRecordingUnit: qmGlobalSettings.recordingScreenRetention.unit,

    retentionActualNonCallValue: formIntToStr(qmGlobalSettings.nonCallRetention.value),
    retentionActualNonCallUnit: qmGlobalSettings.nonCallRetention.unit,

    retentionActualRootRecordingValue: formIntToStr(qmGlobalSettings.recordingAudioRetention.value),
    retentionActualRootRecordingUnit: qmGlobalSettings.recordingAudioRetention.unit,

    ScreenRecordingPriority: qmGlobalSettings.ScreenRecordingPriority,
    screenRecordingBitrate: formIntToStr(SCREEN_RECORDING_BITRATE[qmGlobalSettings.screenRecordingQuality]),
    screenRecordingCPU: formIntToStr(SCREEN_RECORDING_CPU[qmGlobalSettings.screenRecordingQuality]),
    screenRecordingFPS: qmGlobalSettings.screenRecordingFPS,
  }

  if (sharedMediaDirectoryFlag) {
    qmGlobalProps.sharedMediaDirectory = qmGlobalSettings.sharedMediaDirectory
    qmGlobalProps.sharedMediaDirectoryUser = qmGlobalSettings.sharedMediaDirectoryUser
    qmGlobalProps.sharedMediaDirectoryPassword = qmGlobalSettings.sharedMediaDirectoryPassword
  }
  return qmGlobalProps
}

// http://jira/browse/SAAS-59595
// The 'usedFirstCalling' and 'useFirstCalled' fields expect 'true'/'false' string on the backend.
// These are the only fields that require this (other fields will accept '0'/'1') and will need to be refactored at some point.
const formBoolToTrueFalseStr = formBool => (formBool ? 'true' : 'false')
const trueFalseStrToFormBool = str => (!str || str === 'false' ? false : true)

export const qmGlobalSettingsPropertiesToConstraints = qmGlobalSettings => ({
  maxRecordingRetention: {
    value: qmGlobalSettings[DESKTOP_PROPERTIES.RETENTION_DURATION_MAX_VOICE_VALUE],
    unit: qmGlobalSettings[DESKTOP_PROPERTIES.RETENTION_DURATION_MAX_VOICE_UNIT],
  },
  maxReconciliationRetention: {
    value: qmGlobalSettings[DESKTOP_PROPERTIES.RETENTION_MAX_RECONCILIATION_DATA_VALUE],
    unit: qmGlobalSettings[DESKTOP_PROPERTIES.RETENTION_MAX_RECONCILIATION_DATA_UNIT],
  },
  maxRecycleBinRetention: {
    value: qmGlobalSettings[DESKTOP_PROPERTIES.RETENTION_MAX_RECYCLE_BIN_VALUE],
    unit: qmGlobalSettings[DESKTOP_PROPERTIES.RETENTION_MAX_RECYCLE_BIN_UNIT],
  },
  maxNonCallRetention: {
    value: qmGlobalSettings[DESKTOP_PROPERTIES.RETENTION_MAX_NON_CALL_VALUE],
    unit: qmGlobalSettings[DESKTOP_PROPERTIES.RETENTION_MAX_NON_CALL_UNIT],
  },
})
